import React from "react";
import InformationCard from "./InformationCard";
import { faDraftingCompass, faGlobeEurope, faIndustry } from "@fortawesome/free-solid-svg-icons";
import "../Styles/Info.css";

function Info() {
  return (
    <div className="info-section" id="services">
      <div className="info-title-content">
        <h3 className="info-title">
          <span>What We Do</span>
        </h3>
        <p className="info-description">

          At <strong>SNS Enterprises</strong>, we craft and export premium <strong>South Indian flamed grey granites</strong> tailored for <strong>European outdoor architecture</strong>.
        </p>
      </div>

      <div className="info-cards-content">
        <InformationCard
          title="Global Packaging & Delivery"
          description="We ensure safe global delivery through strong 
          wooden crate packaging suitable for 20 ft and 28 ft containers, 
          maintaining our commitment to timely shipment and reliability."
          icon={faGlobeEurope}
        />

        <InformationCard
          title="Quality & Precision"
          description=" Each tile undergoes strict quality inspection and 
          precise calibration to ensure uniform texture, colour consistency, 
          and anti-slip surface finishing that meet European standards."
          icon={faDraftingCompass}
        />

        <InformationCard
          title="Granite Manufacturing & Export"
          description="At SNS Enterprises, we craft and export premium South Indian flamed grey granites for European outdoor architecture, 
          including metro pavements, footpaths, and landscape projects. We also supply high-quality slabs and tiles in flamed, 
          honed, lapotra, and other finishes to meet diverse design needs."
          icon={faIndustry}
        />
      </div>
    </div>
  );
}

export default Info;
